﻿import { blankWinnerAddress, copyWinnerAddress, WinnerAddress } from './winner-address';

export interface WinnerContact {
  questionnaireId: number;
  contactName: string;
  companyName: string;
  addresses: WinnerAddress[];
  companyWebsite: string;
}

export function blankWinnerContact(): WinnerContact {
  return {
    questionnaireId: 0,
    contactName: '',
    companyName: '',
    addresses: [
      blankWinnerAddress(0, 'Celebratory-Item')
    ],
    companyWebsite: '',
  };
}

export function copyWinnerContact(winnerContact: WinnerContact): WinnerContact {
  const addresses: WinnerAddress[] = [];
  winnerContact.addresses.forEach(address => addresses.push(copyWinnerAddress(address)));

  return {
    questionnaireId: winnerContact.questionnaireId,
    contactName: winnerContact.contactName,
    companyName: winnerContact.companyName,
    addresses,
    companyWebsite: winnerContact.companyWebsite,
  };
}
